// extracted by mini-css-extract-plugin
module.exports = {"imageProgressContainer":"styles_imageProgressContainer__2_rmW","container":"styles_container__3iB0h","image":"styles_image__2fphC"};